<template>
  <div v-if="hasLoaded && masterCampaign">
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/crm/campaigns"> Campaigns</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">Edit campaign</li>
    </vs-breadcrumb>
    <form-wizard
      ref="form"
      color="rgba(var(--vs-primary), 1)"
      title="Master Campaign"
      :subtitle="'Status: ' + masterStatusObject(masterCampaign.masterStatus).text"
      finishButtonText="Submit"
      :startIndex="curStatusIndex"
    >
      <!-- tab 1 content -->
      <tab-content title="Campaign setup" lazy="true">
        <vs-row vs-justify="center">
          <vs-button @click="activateCampaign" :disabled="curStatusIndex != 0" class="my-4 py-5"
            >Start the campaign</vs-button
          >
        </vs-row>
        <master-campaign-step-1
          :master-campaign="masterCampaign"
          :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          v-on:onSave="onSave"
        />
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Campaign approval process" lazy="true">
        <vs-row vs-justify="center">
          <vs-button @click="goToStep3" :disabled="curStatusIndex != 1" class="my-4 py-5"
            >Go to send step</vs-button
          >
        </vs-row>
        <master-campaign-step-2 :master-campaign="masterCampaign" v-on:onSave="onSave" />
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Send Campaign to guests" lazy="true">
        <vs-row vs-justify="center">
          <vs-button
            @click="sendCampaign"
            :disabled="masterCampaign.masterStatus != 'Active' || numApprovedVenueCampaigns == 0 || !$AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
            class="my-4 py-5"
            >Send Campaign</vs-button
          >
        </vs-row>
        <master-campaign-step-3 :master-campaign="masterCampaign" v-on:onSave="onSave" />
      </tab-content>

      <!-- tab 4 content -->
      <tab-content title="Statistics" lazy="true">
        <master-campaign-step-4
          v-if="masterCampaign.masterStatus == 'Completed'"
          :master-campaign="masterCampaign"
        />
      </tab-content>

      <!-- <template slot="step" scope="props">
        <wizard-step
          :tab="props.tab"
          :transition="props.transition"
          :key="props.tab.title"
          :index="props.index"
        >
          <feather-icon v-if="props.tab == 0" icon="EditIcon" svgClasses="h-6 w-6" class="ml-1" />
        </wizard-step>
      </template> -->

      <!-- Removes footer -->
      <template slot="footer">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer- right"></div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MasterCampaignStep1 from "./Components/MasterCampaign/MasterCampaignStep1.vue";
import MasterCampaignStep2 from "./Components/MasterCampaign/MasterCampaignStep2.vue";
import MasterCampaignStep3 from "./Components/MasterCampaign/MasterCampaignStep3.vue";
import MasterCampaignStep4 from "./Components/MasterCampaign/MasterCampaignStep4.vue";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  mixins: [campaignMixin],
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    MasterCampaignStep1,
    MasterCampaignStep2,
    MasterCampaignStep3,
    MasterCampaignStep4,
  },
  data() {
    return {
      hasLoaded: false,
    };
  },
  async mounted() {},
  methods: {
    async activateCampaign() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: `Are you sure you want to Activate this Campaign? It will be distributed to ${this.masterCampaign.venues.length} venues, which may then customize it. You will not be able to edit this campaign (step 1) any more. Nothing will be sent to any guests by proceeding to step 2.`,
        accept: async () => {
          try {
            this.$vs.loading({ text: "Activating campaign..." });
            await this.$store.dispatch("masterCampaigns/activateCampaign", this.masterCampaign.id);
            this.$vs.notify({
              color: "green",
              title: "Campaign activated",
              text: "The campaign was successfully activated",
            });

            this.$refs.form.nextTab();
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign not activated",
              text: err,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },
    goToStep3() {
      this.$refs.form.nextTab();
    },
    async sendCampaign() {
      if (this.numApprovedVenueCampaigns == 0) return;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: `Are you sure you want to Send this Campaign? It will be sent to the guests of ${this.numApprovedVenueCampaigns} venues.`,
        accept: async () => {
          try {
            this.$vs.loading({ text: "Sending campaign..." });
            await this.$store.dispatch("masterCampaigns/sendCampaign", this.masterCampaign.id);
            this.$vs.notify({
              color: "green",
              title: "Campaign sent",
              text: "The campaign was successfully sent",
            });

            this.$refs.form.nextTab();
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign not sent",
              text: err,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },
    async onSave() {
      console.log("Clicked save", this.masterCampaign);

      //Call service
      try {
        await this.$store.dispatch("masterCampaigns/update", this.masterCampaign);
        this.$vs.notify({
          color: "green",
          title: "Campaign updated",
          text: "The campaign was successfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign updated",
          text: "Could not update the campaign",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      masterCampaign: "masterCampaigns/masterCampaign",
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      activeVenue: "users/userId",
    }),
    curStatusIndex() {
      switch (this.masterCampaign.masterStatus) {
        case "Draft":
          return 0;
        case "Active":
          return 1;
        case "Completed":
          return 3;
        default:
          return 0;
      }
    },
    numApprovedVenueCampaigns() {
      return this.venueCampaigns.filter(e => e.status == "Approved").length;
    },
    isEditable() {
      return this.masterCampaign.masterStatus == "Draft";
    },
  },
  async created() {
    var masterCampaignId = this.$route.params.id;

    this.hasLoaded = false;
    await this.$store.dispatch("masterCampaigns/get", masterCampaignId);
    this.hasLoaded = true;
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
